import { appLogging } from "./appLogging";

export const { visitIds } = appLogging;

export const VISIT_ID_KEY = visitIds.idKey;
export const VISIT_LAST_SEEN_KEY = visitIds.lastSeenKey;
export const { getVisitId } = visitIds;
